"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CALLBACK_FREQUENCY = void 0;
var CALLBACK_FREQUENCY = Object.freeze({
  CHANGE: 'change',
  ALWAYS: 'always'
});
exports.CALLBACK_FREQUENCY = CALLBACK_FREQUENCY;